/**
 * Widget-specific utility functions.
 * General analytics utilities have been moved to src/utils/analytics.ts
 */

let textMeasureCanvas: HTMLCanvasElement | null = null;

export const measureTextWidth = (text: string, font: string): number => {
    if (typeof document === "undefined") {
        return text.length * 7;
    }

    if (!textMeasureCanvas) {
        textMeasureCanvas = document.createElement("canvas");
    }

    const context = textMeasureCanvas.getContext("2d");
    if (!context) {
        return text.length * 7;
    }

    context.font = font;
    return context.measureText(text).width;
};

export const truncateAxisLabelToWidth = (label: string, maxWidthPx: number, font: string): string => {
    if (measureTextWidth(label, font) <= maxWidthPx) {
        return label;
    }

    const ellipsis = "...";
    const ellipsisWidth = measureTextWidth(ellipsis, font);
    const availableWidth = Math.max(0, maxWidthPx - ellipsisWidth);
    const words = label.trim().split(/\s+/).filter(Boolean);

    if (words.length > 1) {
        let wholeWordResult = "";
        for (const word of words) {
            const candidate = wholeWordResult ? `${wholeWordResult} ${word}` : word;
            if (measureTextWidth(candidate, font) <= availableWidth) {
                wholeWordResult = candidate;
            } else {
                break;
            }
        }

        if (wholeWordResult) {
            return `${wholeWordResult}${ellipsis}`;
        }
    }

    // Fallback for very long single-word labels.
    let truncated = label;
    while (truncated.length > 0 && measureTextWidth(truncated, font) > availableWidth) {
        truncated = truncated.slice(0, -1);
    }

    return `${truncated}${ellipsis}`;
};

// Re-export all utilities from the shared location for backwards compatibility
export * from "../../../utils/analytics";
